import type { FgaAssignableRelation } from './generated/model'

/**
 * The supplier permission vocabulary a permission set configures. Orthogonal rather than tiered, so
 * one toggle is one tuple. Seeing the record is not among them — it derives from holding any
 * permission at all.
 */
export const SUPPLIER_PERMISSIONS = [
  'view_tprm',
  'view_related_requests',
  'view_related_agreements',
  'view_related_documents',
  'view_related_submissions',
  'edit',
  'manage_documents',
  'manage_internal_contacts',
  'manage_external_contacts',
  'manage_products',
  'add_agreement',
  'configure_fields',
  'administer',
] as const

export type SupplierPermission = (typeof SUPPLIER_PERMISSIONS)[number]

/**
 * What a flat assignee held before access became grantable. Despite the name, nothing provisions this
 * — a set created through the API confers nothing until an organisation enables a permission.
 * Benchmarks and parity tests use it to stand in for the pre-grant access.
 */
export const DEFAULT_SUPPLIER_PERMISSIONS: readonly SupplierPermission[] = SUPPLIER_PERMISSIONS.filter(
  (permission) => permission !== 'configure_fields' && permission !== 'administer'
)

export const supplierGrantsRelation = (
  permission: SupplierPermission
): Extract<FgaAssignableRelation<'supplier_permission_set'>, `grants_${string}`> => `grants_${permission}`
